export default __webpack_public_path__ + "static/media/dry-cleaning.75b8cbd8.svg";